export default {
    index: '/',
    jobs: {
        show: '/{job}'
    }
}
